import { klona } from 'klona';
import { storagePrefixFixedV2 } from '@/constant';

export const THEME_MODE = [
  {
    name: '山谷空灵',
    themeId: 'Valley',
    imageUrl: storagePrefixFixedV2 + '/videos/immer-mode/asf-min.png',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/immer-mode-sgkl.mp4',
  },
  {
    name: '火光暖意',
    themeId: 'Fire',
    imageUrl: storagePrefixFixedV2 + '/videos/immer-mode/adqwf-min.png',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/immer-mode-hgly.mp4',
  },
  {
    name: '海浪轻吟',
    themeId: 'Seawave',
    imageUrl: storagePrefixFixedV2 + '/videos/immer-mode/adaf-min.png',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/immer-mode-hlqy-6.mp4',
  },
  {
    name: '冥想澄心',
    themeId: 'Meditation',
    imageUrl: storagePrefixFixedV2 + '/videos/immer-mode/dqwfqg-min.png',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/immer-mode-mxcx.mp4',
  },
  {
    name: '雨声伴眠',
    themeId: 'Rain',
    imageUrl: storagePrefixFixedV2 + '/videos/immer-mode/wqfqwgqwg-min.png',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/immer-mode-ysbm.mp4',
  },
];

export enum MusicThemeText {
  Seawave = '海浪轻吟',
  Valley = '山谷空灵',
  Fire = '火光暖意',
  Rain = '雨声伴眠',
  Meditation = '冥想澄心',
}

// export const TEXTS = [
//   {
//     category: '暂停',
//     priority: 0,
//     texts: ['歇一会再按', '先别按了', '暂停', '暂时歇会', '暂时停一会'],
//   },
//   {
//     category: '调整音量',
//     priority: 1,
//     texts: ['音量大点', '小点声', '音量高点', '音量小点', '音量低点'],
//   },
//   {
//     category: '静音',
//     priority: 1,
//     texts: ['安静一点', '别说话了', '我要休息了', '别出声', '安静一会'],
//   },
// ];

export const SOUND_WAVE_BG_WHITE = storagePrefixFixedV2 + '/image/immer-mode/sound-wave-white.png';

interface BubbleCoord {
  left?: string;
  right?: string;
  top: string;
  pos: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

// 文本气泡合法坐标值
export const VALID_BUBBLE_COORD: BubbleCoord[] = [
  {
    left: '10%',
    top: '28%',
    pos: 'top-left',
  },
  {
    right: '10%',
    top: '28%',
    pos: 'top-right',
  },
  {
    left: '10%',
    top: '39%',
    pos: 'top-left',
  },
  {
    right: '10%',
    top: '39%',
    pos: 'top-right',
  },
  {
    left: '10%',
    top: '50%',
    pos: 'top-left',
  },
  {
    right: '10%',
    top: '50%',
    pos: 'top-right',
  },
  {
    left: '10%',
    top: '61%',
    pos: 'top-left',
  },
  {
    right: '10%',
    top: '61%',
    pos: 'top-right',
  },
  // {
  //   left: '20%',
  //   top: '50%',
  //   pos: 'bottom-left',
  // },
  // {
  //   left: '42%',
  //   top: '50%',
  //   pos: 'top-left',
  // },
  // {
  //   left: '66%',
  //   top: '50%',
  //   pos: 'top-right',
  // },
];

/**
 * ```ts
 *  [
 *    ['1', '2', '4'],
 *    ['a', 'b', 'c'],
 *    ['?', ':', '!'],
 *  ]
 * ```
 * 从非常驻文本中依次从子数组中随机取值，取完值时循环操作
 */
export class RandomArrayPicker<T extends any[]> {
  private backupProps = null;
  private items = null;
  private currentPickIndex = 0;

  constructor(props: T) {
    this.items = klona(props);
    this.backupProps = props;
  }

  private getRandomElementAndRemove(arr: any[]) {
    if (arr.length === 0) {
      return null;
    }

    const randomIndex = Math.floor(Math.random() * arr.length);
    const randomElement = arr[randomIndex];

    // 删除随机元素
    arr.splice(randomIndex, 1);

    return randomElement;
  }

  getItem(): T[0][0] {
    if (!this?.items?.length) return;
    // 当每一项数组都为空，重置currentPickIndex
    if (this.items?.every(item => item?.length === 0)) {
      this.items = klona(this.backupProps);
      this.currentPickIndex = 0;

      return this.getItem();
    }

    // 当前数组有值，则取值
    if (this.items[this.currentPickIndex]?.length) {
      const itemValue = this.getRandomElementAndRemove(this.items[this.currentPickIndex]);

      this.currentPickIndex = this.currentPickIndex >= this.backupProps?.length - 1 ? 0 : this.currentPickIndex + 1;

      return itemValue;
    } else {
      // 当前数组无值，则取下一个数组
      this.currentPickIndex = this.currentPickIndex >= this.backupProps?.length - 1 ? 0 : this.currentPickIndex + 1;
      return this.getItem();
    }
  }
}
